import gql from "graphql-tag";

export const UPDATE_SETTINGS_BY_USERID = gql`
  mutation ($input: updateUserSettingInput) {
    updateSettingByUserId(input: $input) {
      _id
    }
  }
`;
